/* components/patterns/planAccess.js — строка статуса доступа на карточке текущего тарифа.

   Бэкенд отдаёт в /api/subscription/me/ ключ `access {ok, state}`: открыт ли
   пространству платный доступ (Аналитика, касса, ассистент) и почему нет. Пока
   карточка этого не говорила, закрытое пространство выглядело рабочим: «Текущий:
   Демо, Бесплатно» — и ни слова о том, что разделы недоступны.

   Инвариант (тот же, что у screens/analytics/planLock.js): нет `access`, доступ
   открыт или состояние незнакомо → null, карточка рисуется ровно как раньше.
   Так экран переживает старый бэкенд, а новое состояние не получает чужой текст. */

// Состояния бэкенда (subscriptions/access.py), при которых доступ закрыт.
const NOTES = {
  no_plan: 'Тариф не выбран. Аналитика, касса и ассистент недоступны — выберите тариф.',
  trial_over: 'Бесплатный период закончился. Выберите тариф, чтобы вернуть доступ.',
  expired: 'Тариф закончился. Продлите его, чтобы вернуть доступ.',
};

/* Текст строки статуса или null. access — `subscription.access` из адаптера. */
export function accessNote(access) {
  if (!access || access.ok !== false) return null;
  return Object.prototype.hasOwnProperty.call(NOTES, access.state) ? NOTES[access.state] : null;
}
